<template>
<div style="background: #F6F6F6;padding-bottom: 30px;">
	<solutionHead></solutionHead>
	<div class="wrap">
	
		<router-view></router-view>
	</div>
</div>
</template>

<script>
import solutionHead from '../../components/solutionHead.vue'
export default{
	name:'solutionDetail',
	components:{
		 solutionHead,
	},
	data(){
		return{
			title:'',
			whereForm:"",
		}
	},
	beforeRouteEnter(to, from, next){
		next(vm=>{
			if(to.meta.keepAlive){
				vm.$store.commit( "ADD_CachePage", "solutionDetail")
			}
		})
	},
	beforeRouteUpdate(to,from,next) {
		if(to.meta.keepAlive){
			this.$store.commit( "ADD_CachePage", "solutionDetail")
		}
		next() 
	},
	beforeRouteLeave(to, from, next){
		if(!to.meta.editor){
			this.$store.commit('Del_CachePage')
		}
		next()
	},

}
</script>

<style scoped lang="less">

</style>